import { yupResolver } from "@hookform/resolvers/yup";
import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { ALL_STORE } from "constants/DashboardContanst";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import { formConvertErrorMessage, formValidate } from "helpers/form_helper";
import { checkIsHaveInvoicePos } from "helpers/utils";
import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Row,
  Table,
} from "reactstrap";
import {
  createErrorInvoices,
  listNotificationPropertiesErrorInvoices,
  listTypeInvoiceErrorInvoices,
  resetCreateErrorInvoices,
  resetListNotificationPropertiesErrorInvoices,
  resetListTypeInvoiceErrorInvoices,
} from "store/actions";
import * as yup from "yup";
import SearchInvoice from "./SearchInvoice";
import ChangeInfoModal from "./modal/ChangeInfoModal";
import {
  IS_POS_LABEL,
  KyHieuMauHoaDonList,
  TypeHDList,
  convertDate,
  errorInvoicesLoaiThongBao,
} from "./utils";

const CreateErrorInvoice = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["errorInvoice"]);
  const { t: tt } = useTranslation(["requestInvoiceCode"]);
  const { addToast } = useToasts();

  const Dashboard = useSelector(state => state.Dashboard);
  const {buTenantHeaderInfo, buStoreHeader, tenantCodeHeader, finalBuInfo } = Dashboard;

  const errorInvoices = useSelector(state => state.errorInvoices);
  const {
    loadingListTypeInvoice,
    errorListTypeInvoice,
    listTypeInvoice: errorInvoicesListTypeInvoice,

    loadingListNotificationProperties,
    errorListNotificationProperties,
    listNotificationProperties: errorInvoicesListNotificationProperties,

    loadingCreate,
    errorCreate,
    create: errorInvoicesCreate,
  } = errorInvoices;

  // Search Invoice Modal
  const [dataSearchInvoice, setDataSearchInvoice] = useState([]);
  const [searchInvoiceModal, setSearchInvoiceModal] = useState(false);
  const [isSearchPos, setIsSearchPos] = useState(TypeHDList[0].value);
  const [displaySearchInvoice, setDisplaySearchInvoice] = useState(false);

  // dataChangeInfo Modal
  const [dataChangeInfo, setDataChangeInfo] = useState({});
  const [changeInfoModal, setChangeInfoModal] = useState(false);
  const toggleChangeInfoModal = () => {
    setChangeInfoModal(!changeInfoModal);
  };

  // Show / Hide Field Thông Báo
  const [displayThongBao, setDisplayThongBao] = useState(false);

  let schema = yup.object().shape({
    is_thong_bao: yup.boolean(),
    is_loai_hoa_don: yup.boolean(),
    is_pos: yup
      .object()
      .required(t("form.validate.select", { title: t("form.is_pos") })),
    loai_hoa_don: yup
      .object()
      .required(t("form.validate.select", { title: t("form.loai_hoa_don") })),
    loai_thong_bao: yup
      .object()
      .required(t("form.validate.select", { title: t("form.loai_thong_bao") })),
    so_thong_bao: yup.string().when("is_thong_bao", {
      is: true,
      then: yup
        .string()
        .required(
          t("form.validate.required", { title: t("form.so_thong_bao") })
        ),
    }),
    ngay_thong_bao: yup.array().when("is_thong_bao", {
      is: true,
      then: yup
        .array()
        .min(1, t("form.validate.select", { title: t("form.ngay_thong_bao") })),
    }),
    lines: yup.array().when("is_loai_hoa_don", {
      is: true,
      then: yup
        .array()
        .min(1, t("form.validate.least_one_line"))
        .of(
          yup.object().shape({
            is_pos: yup.number(),
            id_invoice: yup.string().nullable(),
            ma_cqt_cap: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.ma_cqt_cap") })
              ),
            khmhdon: yup
              .object()
              .required(
                t("form.validate.select", { title: t("form.khmhdon") })
              ),
            khhdon: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.khhdon") })
              ),
            // .max(6, t("form.validate.char_max", { max: 6 })),
            so_hoa_don: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.so_hoa_don") })
              )
              .matches(/^[0-9]+$/, t("form.validate.integer")),
            // .max(20, t("form.validate.integer_max", { max: 20 })),
            ngay_lap_hdon: yup
              .array()
              .min(
                1,
                t("form.validate.select", { title: t("form.ngay_lap_hdon") })
              ),
            tchat_thong_bao: yup.object().required(
              t("form.validate.select", {
                title: t("form.tchat_thong_bao"),
              })
            ),
            ly_do: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.ly_do") })
              ),
          })
        ),
      otherwise: yup
        .array()
        .min(1, t("form.validate.least_one_line"))
        .of(
          yup.object().shape({
            is_pos: yup.number(),
            ma_cqt_cap: yup.string(),
            khmhdon: yup
              .object()
              .required(
                t("form.validate.select", { title: t("form.khmhdon") })
              ),
            khhdon: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.khhdon") })
              ),
            // .max(6, t("form.validate.char_max", { max: 6 })),
            so_hoa_don: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.so_hoa_don") })
              )
              .matches(/^[0-9]+$/, t("form.validate.integer")),
            // .max(20, t("form.validate.integer_max", { max: 20 })),
            ngay_lap_hdon: yup
              .array()
              .min(
                1,
                t("form.validate.select", { title: t("form.ngay_lap_hdon") })
              ),
            tchat_thong_bao: yup.object().required(
              t("form.validate.select", {
                title: t("form.tchat_thong_bao"),
              })
            ),
            ly_do: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.ly_do") })
              ),
          })
        ),
    }),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    watch,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      is_thong_bao: false,
      is_loai_hoa_don: true,
      is_pos: TypeHDList[0],
      loai_hoa_don: undefined,
      loai_thong_bao: undefined,
      so_thong_bao: "",
      ngay_thong_bao: [],
      lines: [],
    },
  });

  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "lines", // unique name for your Field Array
      keyName: "key", // keyName: "id", default to "id", you can change the key name
    }
  );

  // Set Default Values
  useEffect(() => {
    const findLoaiThongBao = errorInvoicesLoaiThongBao.find(
      item => item.key === "type1"
    );
    if (findLoaiThongBao) {
      setValue("loai_thong_bao", {
        value: findLoaiThongBao.value,
        label: findLoaiThongBao.label,
      });
    }
  }, []);

  // Get List Data For Select
  useEffect(() => {
    dispatch(listTypeInvoiceErrorInvoices());
    dispatch(listNotificationPropertiesErrorInvoices());
    return () => {
      dispatch(resetListTypeInvoiceErrorInvoices());
      dispatch(resetListNotificationPropertiesErrorInvoices());
    };
  }, [dispatch]);

  // Action Dispatch
  useEffect(() => {
    if (errorInvoicesCreate && errorInvoicesCreate.success) {
      addToast(
        t("message.create", {
          target: t("error_invoice"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      dispatch(resetCreateErrorInvoices());
      history.push("/error-invoices");
    }
  }, [addToast, dispatch, errorInvoicesCreate, history, t]);

  // Error Dispatch
  useEffect(() => {
    if (errorListTypeInvoice) {
      addToast(
        formConvertErrorMessage(
          errorListTypeInvoice.message ||
            t("message.list", {
              target: t("type_invoice"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      dispatch(resetListTypeInvoiceErrorInvoices());
    }

    if (errorListNotificationProperties) {
      addToast(
        formConvertErrorMessage(
          errorListNotificationProperties.message ||
            t("message.list", {
              target: t("notification_properties"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      dispatch(resetListNotificationPropertiesErrorInvoices());
    }

    if (errorCreate) {
      addToast(
        formConvertErrorMessage(
          errorCreate.message ||
            t("message.create", {
              target: t("error_invoice"),
              status: t("message.error"),
            }),
          t
        ),
        { appearance: "error", autoDismiss: true }
      );
      if (errorCreate.code === 422 && errorCreate.fields.length > 0) {
        errorCreate.fields.map(item => {
          let fieldName = item.field;
          switch (item.field) {
            case "common":
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              break;
          }
          setError(fieldName, {
            type: "manual",
            message: formConvertErrorMessage(item.message, t),
          });
        });
      }
      dispatch(resetCreateErrorInvoices());
    }
  }, [
    addToast,
    dispatch,
    errorCreate,
    errorListNotificationProperties,
    errorListTypeInvoice,
    setError,
    t,
  ]);

  const toggleSearchInvoiceModal = (action = "") => {
    setSearchInvoiceModal(!searchInvoiceModal);
    switch (action) {
      case "change":
        // Clear Main Template Version After Selected New List
        // setValue("main_template_version_id", "", { shouldValidate: true });
        break;
      default:
        break;
    }
  };

  const checkThongBaoHandler = () => {
    const valueLoaiThongBao = getValues("loai_thong_bao");
    if (valueLoaiThongBao !== undefined) {
      switch (valueLoaiThongBao.value) {
        case "1":
          setDisplayThongBao(false);
          setValue("is_thong_bao", false);
          break;
        case "2":
          setDisplayThongBao(true);
          setValue("is_thong_bao", true);
          break;
        default:
          break;
      }
    }
  };

  const checkLoaiHoaDonHandler = () => {
    const valueLoaiHoaDon = getValues("loai_hoa_don");

    setValue("lines", [], { shouldValidate: true });

    if (valueLoaiHoaDon !== undefined) {
      switch (valueLoaiHoaDon.value) {
        case "1":
          setValue("is_loai_hoa_don", true);
          setDisplaySearchInvoice(true);
          break;
        default:
          addNewLine();
          setValue("is_loai_hoa_don", false);
          setDisplaySearchInvoice(false);
          break;
      }
    }
  };

  const addNewLine = (dataReplace = null) => {
    append(
      dataReplace || {
        id_invoice: null,
        ma_cqt_cap: "",
        khmhdon: undefined,
        khhdon: "",
        so_hoa_don: "",
        ngay_lap_hdon: [],
        tchat_thong_bao: undefined,
        ly_do: "",
      }
    );
  };

  const onSubmit = values => {
    // toggleTypeSignModal();
    // setTransferData(values);
    callApi(values);
  };

  const removeDataSearchInvoice = index => {
    const lineMustRemove = getValues(`lines.${index}`);
    const filterDataSearchInvoice = dataSearchInvoice.filter(
      item => item.id !== lineMustRemove.id_invoice
    );
    setDataSearchInvoice(filterDataSearchInvoice);
  };

  const callApi = values => {
    // const values = transferData;
    const dataCreate = {
      is_pos: isSearchPos,
      loai: values.loai_thong_bao.value,
      ladhddt: values.loai_hoa_don.value,
      dshdon: [],
      // ntbccqt: "",
      // so: "",
      // dshdon: [
      //   {
      //     LDo: "Hủy",
      //     Ngay: "2022-01-12 14:21:02",
      //     SHDon: "2",
      //     KHHDon: "C22TXX",
      //     TCTBao: 1,
      //     LADHDDT: 1,
      //     MCQTCap: "00363514E4EBC54125B95D763ED4B3A947",
      //     KHMSHDon: "1",
      //     ID: null,
      //   },
      // ],
    };
    if (getValues("is_thong_bao")) {
      dataCreate["ntbccqt"] = convertDate(values.ngay_thong_bao[0], "date");
      dataCreate["so"] = Number(values.so_thong_bao);
    }
    dataCreate.dshdon = values.lines.map(item => {
      const dataChange = item?.CHANGES?.nmua_dchi_new.trim()
        ? {
            nmua_dchi_new: `Địa chỉ đúng: ${item?.CHANGES?.nmua_dchi_new}`,
            nmua_dchi_old: `Địa chỉ trên hóa đơn bị sai: ${item?.CHANGES?.nmua_dchi_old}`,
          }
        : {
            nmua_dchi_new: "",
            nmua_dchi_old: "",
          };
      dataChange.noidung_new = item?.CHANGES?.noidung_new
        ? `Nội dung đúng: ${item?.CHANGES?.noidung_new}`
        : "";
      dataChange.noidung_old = item?.CHANGES?.noidung_old
        ? `Nội dung trên hóa đơn bị sai: ${item?.CHANGES?.noidung_old}`
        : "";
      return {
        LDo: item.ly_do,
        Ngay: convertDate(item.ngay_lap_hdon[0], "date"),
        SHDon: Number(item.so_hoa_don),
        TCTBao: item.tchat_thong_bao.value,
        LADHDDT: values.loai_hoa_don.value,
        MCQTCap: item.ma_cqt_cap,
        KHHDon: item.khhdon,
        KHMSHDon: item.khmhdon.value,
        ID: item.id_invoice || null,
        CHANGES: dataChange,
      };
    });
    dispatch(createErrorInvoices({ ...dataCreate }));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.create")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.create")}
            breadcrumbItems={[
              { name: t("title.manager") },
              { name: t("title.create") },
            ]}
          />

          <Row className="row-cols-1">
            {/* Modal START*/}
            <Col>
              {/* Search Invoice Modal */}
              <SearchInvoice
                isPos={isSearchPos}
                // dataDetail={dataSelectTemplates}
                isOpenModal={searchInvoiceModal}
                toggleModal={toggleSearchInvoiceModal}
                dataSearchInvoice={dataSearchInvoice}
                setDataSearchInvoice={setDataSearchInvoice}
                addNewLine={addNewLine}
              />
              <ChangeInfoModal
                dataChange={dataChangeInfo}
                isOpen={changeInfoModal}
                isShowBtnUpdate={true}
                toggle={toggleChangeInfoModal}
                onUpdate={values => {
                  const index = dataChangeInfo?.index;

                  const curData = watch(`lines`)[index]["CHANGES"];
                  const dataUpdate = {
                    ...curData,
                    ...values,
                  };

                  setValue(`lines.${index}.CHANGES`, dataUpdate, {
                    shouldValidate: true,
                  });
                }}
              />
            </Col>
            {/* Modal E N D*/}
            <Col>
              <Card>
                <CardBody>
                  <Row className="row-cols-1 row-cols-md-2">
                    <Col>
                      <Row>
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="loai_hoa_don">
                              {t("form.loai_hoa_don")}{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Controller
                              control={control}
                              name="loai_hoa_don"
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  placeholder={t("placeholder.select", {
                                    title: t("form.loai_hoa_don"),
                                  })}
                                  options={
                                    errorInvoicesListTypeInvoice &&
                                    errorInvoicesListTypeInvoice.items &&
                                    errorInvoicesListTypeInvoice.items.length >
                                      0
                                      ? errorInvoicesListTypeInvoice.items.map(
                                          item => ({
                                            value: String(item.id),
                                            label: item.value,
                                          })
                                        )
                                      : []
                                  }
                                  onChange={data => {
                                    field.onChange(data);
                                    checkLoaiHoaDonHandler();
                                    setDataSearchInvoice([]);
                                  }}
                                  classNamePrefix="select2-selection"
                                />
                              )}
                            />
                            {errors.loai_hoa_don && (
                              <MessageFormValidate
                                error={errors.loai_hoa_don.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="is_pos">
                              {t("form.is_pos")}{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Controller
                              control={control}
                              name="is_pos"
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  placeholder={t("placeholder.select", {
                                    title: t("form.is_pos"),
                                  })}
                                  options={
                                    checkIsHaveInvoicePos(
                                      buTenantHeaderInfo,
                                      finalBuInfo,
                                      buStoreHeader,
                                      tenantCodeHeader
                                    )
                                      ? TypeHDList
                                      : [TypeHDList[0]]
                                  }
                                  onChange={data => {
                                    field.onChange(data);
                                    setIsSearchPos(data?.value);
                                  }}
                                  classNamePrefix="select2-selection"
                                />
                              )}
                            />
                            {errors.is_pos && (
                              <MessageFormValidate
                                error={errors.is_pos.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>

                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="loai_thong_bao">
                          {t("form.loai_thong_bao")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Controller
                          control={control}
                          name="loai_thong_bao"
                          render={({ field }) => (
                            <Select
                              {...field}
                              placeholder={t("placeholder.select", {
                                title: t("form.loai_thong_bao"),
                              })}
                              options={
                                errorInvoicesLoaiThongBao &&
                                errorInvoicesLoaiThongBao.length > 0
                                  ? errorInvoicesLoaiThongBao.map(item => ({
                                      value: item.value,
                                      label: item.label,
                                    }))
                                  : []
                              }
                              onChange={data => {
                                field.onChange(data);
                                checkThongBaoHandler();
                              }}
                              classNamePrefix="select2-selection"
                            />
                          )}
                        />
                        {errors.loai_thong_bao && (
                          <MessageFormValidate
                            error={errors.loai_thong_bao.message}
                          />
                        )}
                      </FormGroup>
                    </Col>
                    {displayThongBao && (
                      <React.Fragment>
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="so_thong_bao">
                              {t("form.so_thong_bao")}{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <input
                              type="text"
                              className={`form-control ${formValidate(
                                errors,
                                touchedFields,
                                "so_thong_bao"
                              )}`}
                              placeholder={t("placeholder.enter", {
                                title: t("form.so_thong_bao"),
                              })}
                              {...register("so_thong_bao")}
                            />
                            {errors.so_thong_bao && (
                              <MessageFormValidate
                                error={errors.so_thong_bao.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="ngay_thong_bao">
                              {t("form.ngay_thong_bao")}{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Controller
                              control={control}
                              name="ngay_thong_bao"
                              render={({ field }) => (
                                <Flatpickr
                                  {...field}
                                  className="form-control d-block Flatpickr__Input"
                                  placeholder="DD/MM/YYYY"
                                  options={{
                                    altInput: true,
                                    altFormat: "d/m/Y",
                                    dateFormat: "d/m/Y",
                                    locale: {
                                      ...Vietnamese,
                                      firstDayOfWeek: 1,
                                    },
                                  }}
                                  onChange={date => {
                                    field.onChange(date);
                                  }}
                                />
                              )}
                            />
                            {errors.ngay_thong_bao && (
                              <MessageFormValidate
                                error={errors.ngay_thong_bao.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      </React.Fragment>
                    )}
                  </Row>
                  {displaySearchInvoice && (
                    <Row className="mb-2">
                      <Col>
                        <button
                          type="button"
                          className="btn btn-primary btn-label"
                          onClick={() => {
                            toggleSearchInvoiceModal();
                          }}
                        >
                          <i className="fas fa-search-plus label-icon" />
                          {t("form.search_invoice")}
                        </button>
                      </Col>
                    </Row>
                  )}
                  <div className="custom-table-border">
                    <Table className="table table-bordered">
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: "20px" }}>
                            STT
                          </th>
                          <th
                            className="text-center"
                            style={{ width: "130px" }}
                          >
                            Loại áp dụng
                          </th>
                          <th>Mã CQT cấp</th>
                          <th>Ký hiệu mẫu HĐ và ký hiệu HĐ</th>
                          <th>Số HĐ</th>
                          <th>Ngày lập HĐ</th>
                          <th>Tính chất thông báo</th>
                          <th>Lý do</th>
                          <th>Nội dung sai sót bổ sung trong mail</th>
                          <th style={{ width: "20px" }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {fields.map((field, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{IS_POS_LABEL[field?.is_pos]}</td>
                              <td style={{ minWidth: "213px" }}>
                                <textarea
                                  disabled={displaySearchInvoice}
                                  className={`form-control ${formValidate(
                                    errors,
                                    touchedFields,
                                    `lines.${index}.ma_cqt_cap`
                                  )}`}
                                  placeholder={t("placeholder.enter", {
                                    title: t("form.ma_cqt_cap"),
                                  })}
                                  {...register(`lines.${index}.ma_cqt_cap`)}
                                />
                                {errors.lines &&
                                  errors.lines[index] &&
                                  errors.lines[index].ma_cqt_cap && (
                                    <MessageFormValidate
                                      error={
                                        errors.lines[index].ma_cqt_cap.message
                                      }
                                    />
                                  )}
                              </td>
                              <td>
                                <div className="d-flex gap-2">
                                  <div
                                    style={{
                                      flex: "auto",
                                      minWidth: "82px",
                                    }}
                                  >
                                    <Controller
                                      control={control}
                                      name={`lines.${index}.khmhdon`}
                                      render={({ field }) => (
                                        <CreatableSelect
                                          {...field}
                                          isDisabled={displaySearchInvoice}
                                          placeholder={t("placeholder.select", {
                                            title: t("form.khmhdon"),
                                          })}
                                          options={
                                            KyHieuMauHoaDonList &&
                                            KyHieuMauHoaDonList.length > 0
                                              ? KyHieuMauHoaDonList.map(
                                                  item => ({
                                                    value: item.value,
                                                    label: item.label,
                                                  })
                                                )
                                              : []
                                          }
                                          classNamePrefix="select2-selection"
                                        />
                                      )}
                                    />
                                    {errors.lines &&
                                      errors.lines[index] &&
                                      errors.lines[index].khmhdon && (
                                        <MessageFormValidate
                                          error={
                                            errors.lines[index].khmhdon.message
                                          }
                                        />
                                      )}
                                  </div>
                                  <div style={{ width: "50%" }}>
                                    <Controller
                                      control={control}
                                      name={`lines.${index}.khhdon`}
                                      render={({ field }) => (
                                        <input
                                          {...field}
                                          disabled={displaySearchInvoice}
                                          type="text"
                                          className={`form-control ${formValidate(
                                            errors,
                                            touchedFields,
                                            `lines.${index}.khhdon`
                                          )}`}
                                          onChange={data => {
                                            field.onChange(
                                              data.target.value.toUpperCase()
                                            );
                                          }}
                                          placeholder={t("placeholder.enter", {
                                            title: t("form.khhdon"),
                                          })}
                                        />
                                      )}
                                    />
                                    {errors.lines &&
                                      errors.lines[index] &&
                                      errors.lines[index].khhdon && (
                                        <MessageFormValidate
                                          error={
                                            errors.lines[index].khhdon.message
                                          }
                                        />
                                      )}
                                  </div>
                                </div>
                              </td>
                              <td style={{ minWidth: "100px", width: "100px" }}>
                                <input
                                  disabled={displaySearchInvoice}
                                  type="number"
                                  className={`form-control ${formValidate(
                                    errors,
                                    touchedFields,
                                    `lines.${index}.so_hoa_don`
                                  )}`}
                                  placeholder={t("placeholder.enter", {
                                    title: t("form.so_hoa_don"),
                                  })}
                                  {...register(`lines.${index}.so_hoa_don`)}
                                />
                                {errors.lines &&
                                  errors.lines[index] &&
                                  errors.lines[index].so_hoa_don && (
                                    <MessageFormValidate
                                      error={
                                        errors.lines[index].so_hoa_don.message
                                      }
                                    />
                                  )}
                              </td>
                              <td style={{ maxWidth: "143px", width: "143px" }}>
                                <Controller
                                  control={control}
                                  name={`lines.${index}.ngay_lap_hdon`}
                                  render={({ field }) => (
                                    <Flatpickr
                                      {...field}
                                      disabled={displaySearchInvoice}
                                      className="form-control d-block Flatpickr__Input"
                                      placeholder="DD/MM/YYYY"
                                      options={{
                                        altInput: true,
                                        altFormat: "d/m/Y",
                                        dateFormat: "d/m/Y",
                                        locale: {
                                          ...Vietnamese,
                                          firstDayOfWeek: 1,
                                        },
                                      }}
                                      onChange={date => {
                                        field.onChange(date);
                                      }}
                                    />
                                  )}
                                />
                                {errors.lines &&
                                  errors.lines[index] &&
                                  errors.lines[index].ngay_lap_hdon && (
                                    <MessageFormValidate
                                      error={
                                        errors.lines[index].ngay_lap_hdon
                                          .message
                                      }
                                    />
                                  )}
                              </td>
                              <td style={{ minWidth: "170px", width: "170px" }}>
                                <Controller
                                  control={control}
                                  name={`lines.${index}.tchat_thong_bao`}
                                  render={({ field }) => (
                                    <Select
                                      {...field}
                                      placeholder={t("placeholder.select", {
                                        // title: t("form.tchat_thong_bao"),
                                      })}
                                      options={
                                        errorInvoicesListNotificationProperties &&
                                        errorInvoicesListNotificationProperties.items &&
                                        errorInvoicesListNotificationProperties
                                          .items.length > 0
                                          ? errorInvoicesListNotificationProperties.items.map(
                                              item => ({
                                                value: item.id,
                                                label: item.value,
                                              })
                                            )
                                          : []
                                      }
                                      classNamePrefix="select2-selection"
                                    />
                                  )}
                                />
                                {errors.lines &&
                                  errors.lines[index] &&
                                  errors.lines[index].tchat_thong_bao && (
                                    <MessageFormValidate
                                      error={
                                        errors.lines[index].tchat_thong_bao
                                          .message
                                      }
                                    />
                                  )}
                              </td>
                              <td style={{ minWidth: "200px" }}>
                                <input
                                  type="text"
                                  className={`form-control ${formValidate(
                                    errors,
                                    touchedFields,
                                    `lines.${index}.ly_do`
                                  )}`}
                                  placeholder={t("placeholder.enter", {
                                    title: t("form.ly_do"),
                                  })}
                                  {...register(`lines.${index}.ly_do`)}
                                />
                                {errors.lines &&
                                  errors.lines[index] &&
                                  errors.lines[index].ly_do && (
                                    <MessageFormValidate
                                      error={errors.lines[index].ly_do.message}
                                    />
                                  )}
                              </td>
                              <td
                                className="text-center text-info"
                                style={{
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                  minWidth: "200px",
                                  width: "200px",
                                }}
                                onClick={() => {
                                  const dataLine = watch(`lines`)[index];

                                  if (dataLine?.CHANGES) {
                                    setDataChangeInfo({
                                      nmua_dchi_old:
                                        dataLine?.CHANGES.nmua_dchi_old || "",
                                      nmua_dchi_new:
                                        dataLine?.CHANGES?.nmua_dchi_new || "",
                                      index: index,
                                    });
                                  } else {
                                    setDataChangeInfo({});
                                  }

                                  toggleChangeInfoModal();
                                }}
                              >
                                Xem nội dung
                              </td>
                              <td>
                                <React.Fragment>
                                  <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                                    {displaySearchInvoice ? (
                                      <React.Fragment>
                                        {fields.length >= 1 && (
                                          <i
                                            onClick={() => {
                                              removeDataSearchInvoice(index);
                                              remove(index);
                                            }}
                                            className="fas fa-trash fa-lg text-danger"
                                            style={{ cursor: "pointer" }}
                                          />
                                        )}
                                      </React.Fragment>
                                    ) : (
                                      <React.Fragment>
                                        {fields.length > 1 && (
                                          <i
                                            onClick={() => {
                                              remove(index);
                                            }}
                                            className="fas fa-trash fa-lg text-danger"
                                            style={{ cursor: "pointer" }}
                                          />
                                        )}

                                        {index === fields.length - 1 && (
                                          <i
                                            onClick={addNewLine}
                                            className="fas fa-plus fa-lg text-success"
                                            style={{ cursor: "pointer" }}
                                          ></i>
                                        )}
                                      </React.Fragment>
                                    )}
                                  </div>
                                </React.Fragment>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    {errors.lines && (
                      <MessageFormValidate error={errors.lines.message} />
                    )}
                  </div>
                  <Row className="justify-content-end">
                    <Col className="col-auto">
                      <Link
                        to="/error-invoices"
                        className="btn btn-danger btn-label"
                      >
                        <i className="fas fa-undo label-icon"></i>
                        {t("form.cancel")}
                      </Link>
                    </Col>
                    <Col className="col-auto">
                      <Button
                        color="primary"
                        className="btn-label"
                        type="button"
                        onClick={() => {
                          handleSubmit(onSubmit)();
                        }}
                        disabled={loadingCreate || buStoreHeader === ALL_STORE}
                      >
                        <i className="far fa-save label-icon"></i>
                        {t("form.save")}
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateErrorInvoice;
